import "preact/debug";
import headerStyles from "./header.module.css";

export function NewsLetter({ link }) {
  return (
    <div class={headerStyles["newsletter"]}>
      <span
        class={`material-symbols-outlined ${headerStyles["newsletter-icon"]} mb-2`}
      >
        {link.megaMenu.newsletter.icon}
      </span>
      <h3 class={`${headerStyles["newsletter-heading"]} mb-2`}>
        {link.megaMenu.newsletter.heading}
      </h3>
      <p class="mb-3">{link.megaMenu.newsletter.text}</p>
      <a href={link.megaMenu.newsletter.link.url} class="button __white">
        {link.megaMenu.newsletter.link.name}
      </a>
    </div>
  );
}
